import { Outlet } from "react-router-dom"
import { BackgroundBlocker } from "../../shared/background-blocker"
import { Header } from "../../shared/header"
import { ProfileMenu } from "../../shared/profile-menu"
import { BaseContext } from "../../shared/base-context"
import React, { useContext } from "react"
import { useAnalyticsTracker } from "../../shared/hooks/useAnalyticsTracker"

const MemoizedBackgroundBlocker = React.memo(BackgroundBlocker)
const MemoizedProfileMenu = React.memo(ProfileMenu)
const MemoizedOutlet = React.memo(Outlet)

export const Main = () => {
    const { isSidebarShown } = useContext(BaseContext);
    useAnalyticsTracker();
    return (
        <>
            <Header />
            <section className='h-screen flex flex-col px-2 lg:px-6'>
                {isSidebarShown ? (
                    <>
                        <MemoizedBackgroundBlocker />
                        <MemoizedProfileMenu />
                    </>
                ) : null}
                <MemoizedOutlet />
            </section>
        </>
    )
}